import Scriba from 'react-scriba';

export class DataMonCompte {

    static _chargementDroitsLiesAuxActualites = () => {
        const url = "api/Droit/ListeDesDroitsLiesAuxActualites";
        const paramPost = Scriba.fetch().createParameterPost({});
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementDroitsLiesAuxAlarmes = () => {
        const url = "api/Droit/ListeDesDroitsLiesAuxAlarmes";
        const paramPost = Scriba.fetch().createParameterPost({});
        return fetch(url, paramPost).then(response => response.json());
    };

};